import {compress, decompress} from "lz-string";

/**
 * Metodo che ricevuto un parametro in input, lo cifra e lo restituisce
 * @param {*} inputData 
 * @returns 
 */
export function encryptData (inputData) {
    let encryptedData = null;
    if (inputData) {
        encryptedData = compress(inputData);
    }
    return encryptedData;
}

/**
 * Metodo che ricevuto un parametro in input, lo decifra e lo restituisce
 * @param {*} inputData 
 * @returns 
 */
export function decryptData (inputData) {
    let decryptedData = null;
    if (inputData) {
        decryptedData = decompress(inputData);
    }
    return decryptedData;
}
